export const API = {
  BASE_URL: process.env.REACT_APP_API_URL,
  LOGOUT: "/logout",
  REQUEST_TOKEN: "/services/oauth2/token",
  TOKEN_POLLING: "/services/oauth2/token-polling",
  REFRESH_TOKEN: "/refresh-token",
  ALL_ACCOUNTS: "/accounts",
  ALL_OBJECTS: "/objects",
  OBJECT: "/object",
  QUERY: "/query",
  ACCOUNT_IDENTITY: "/identity",
  GET_IMAGE_FROM_URL: "/get-images",
  GET_IMAGE_FROM_RICH_TEXT: "/get-images-from-richtext",
};
export const LocalStorageKeys = {
  CREDENTIALS: "cred",
  LOGGED: "logged",
  LOGIN: "login",
  CONFIG: "config",
};

export const mergeStyle = {
  DATA_MERGE: "DATA_MERGE",
  XML_MERGE: "XML_MERGE",
};

export const DELAY = 800;
// export const REFRESH_ACCESS_TOKEN_INTERVAL = 1000 * 60 * 4;
export const OAUTH_TOKEN_POLLING_INTERVAL = 1000 * 5;

export const mimeTypes = {
  // Text
  txt: "text/plain",
  html: "text/html",
  css: "text/css",
  js: "text/javascript",
  xml: "application/xml",

  // Images
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  bmp: "image/bmp",
  svg: "image/svg+xml",

  // Audio
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  aac: "audio/aac",

  // Video
  mp4: "video/mp4",
  webm: "video/webm",
  ogv: "video/ogg",

  // Documents
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",

  // Archives
  zip: "application/zip",
  rar: "application/x-rar-compressed",
  tar: "application/x-tar",
  gz: "application/gzip",

  // Fonts
  ttf: "font/ttf",
  otf: "font/otf",
  woff: "font/woff",
  woff2: "font/woff2",

  // Application
  json: "application/json",
  ics: "text/calendar",
  rdf: "application/rdf+xml",
  rss: "application/rss+xml",
  xhtml: "application/xhtml+xml",
};

export const errorTypes = {
  PAYLOAD_ERROR: "payloadError",
};
